/* tslint:disable */
/* eslint-disable */
/**
 * e-SNRWB
 * Opis api e-SNRWB
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUpdateMisstatementDto
 */
export interface CreateUpdateMisstatementDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateMisstatementDto
     */
    varianceId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateMisstatementDto
     */
    inspectedProductId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateMisstatementDto
     */
    other: string;
}

export function CreateUpdateMisstatementDtoFromJSON(json: any): CreateUpdateMisstatementDto {
    return CreateUpdateMisstatementDtoFromJSONTyped(json, false);
}

export function CreateUpdateMisstatementDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateMisstatementDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'varianceId': json['varianceId'],
        'inspectedProductId': json['inspectedProductId'],
        'other': json['other'],
    };
}

export function CreateUpdateMisstatementDtoToJSON(value?: CreateUpdateMisstatementDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'varianceId': value.varianceId,
        'inspectedProductId': value.inspectedProductId,
        'other': value.other,
    };
}


